import { Form, TextArea } from 'semantic-ui-react';

import { HEALTH_INFORMATION_MAX_LENGTH } from '../../../utils/registration';

/**
 * Health information the person chose to share — one free-text box, up to 1000 characters.
 *
 * **Who sees it afterwards is narrower than who types it.** Admins and social workers can read it
 * on the profile; centre managers, who enter it here at intake, cannot (owner, 2026-11-03). The
 * hint says so, so nobody is surprised when it is not on the profile they just created.
 */
export const HealthSection = ({
    value,
    onChange,
}: {
    value: string;
    onChange: (next: string) => void;
}) => (
    <div className="creator-section">
        <div className="creator-section-title">Health information</div>
        <p className="creator-section-hint">
            Anything about their health they have chosen to share. Optional. Only admins and social
            workers can see this on their profile afterwards.
        </p>
        <Form.Field>
            <label htmlFor="health-information">Health information they have shared</label>
            <TextArea
                id="health-information"
                rows={5}
                maxLength={HEALTH_INFORMATION_MAX_LENGTH}
                value={value}
                onChange={(_, d) => onChange(String(d.value ?? ''))}
            />
            <div className="field-counter">{value.length} / {HEALTH_INFORMATION_MAX_LENGTH}</div>
        </Form.Field>
    </div>
);
